import { createContext, useContext } from 'react';
import { AnalyticsResponse } from '../types';

// Your existing state interface
export interface ProjectLibraryState {
    analyticsData: AnalyticsResponse | null;
    isLoading: boolean;
}

// New interface for setters
export interface ProjectLibrarySetters {
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

// Update the context to include both state and setters
export interface AnalyticsContextType {
    state: ProjectLibraryState;
    setters: ProjectLibrarySetters;
    refresh: (showSpinner?: boolean) => Promise<void>;
}

export const AnalyticsContext = createContext<AnalyticsContextType | null>(
    null,
);

export function useAnalyticsContext() {
    const analyticsContext = useContext(AnalyticsContext);

    if (analyticsContext === null) {
        throw new Error(
            'useAnalyticsContext must be used with a AnalyticsContext',
        );
    }

    return analyticsContext;
}
